import Vue from 'vue'
import VueI18n from 'vue-i18n'
import storage from 'store'
import moment from 'moment'
import { APP_LANGUAGE } from '@/store/mutation-types'
import zhCN from './lang/zh-CN'
import jaJP from './lang/ja-JP'

Vue.use(VueI18n)

export const defaultLang = 'zh-CN'
export const supportedLanguages = ['zh-CN', 'ja-JP']
export const normalizeLanguage = lang => supportedLanguages.includes(lang) ? lang : defaultLang

// Both supported languages ship with the app, including the login screen.
const messages = { 'zh-CN': zhCN, 'ja-JP': jaJP }
const initialLanguage = normalizeLanguage(storage.get(APP_LANGUAGE, defaultLang))
const i18n = new VueI18n({
  silentTranslationWarn: true,
  locale: initialLanguage,
  fallbackLocale: defaultLang,
  messages
})

export function loadLanguageAsync (language = defaultLang) {
  const lang = normalizeLanguage(language)
  i18n.locale = lang
  moment.locale(messages[lang].momentName)
  storage.set(APP_LANGUAGE, lang)
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', lang)
  }
  return Promise.resolve(lang)
}

loadLanguageAsync(initialLanguage)

// API-provided route titles pass through unchanged unless they are i18n keys.
export function i18nRender (key) {
  return i18n.t(String(key))
}

export default i18n
